import React from "react";
import MapPreviewImage from "../../assets/images/map-preview.png";


interface ProjectOverviewLocationMapProps {
    isMapEnabled: boolean;
    props: any;
    setIsMapEnabled: React.Dispatch<React.SetStateAction<boolean>>;
}

export function ProjectOverviewLocationMap({ isMapEnabled,
    props,
    setIsMapEnabled }: ProjectOverviewLocationMapProps) {
    return (
        <div className="row border-top pt-5">
            <div className="col-12 px-0">
                <h2 className="mb-4" style={{ fontSize: "21px" }}>
                    Location Map
                </h2>
            </div>
            <div className="col px-0 mb-3" style={{ maxWidth: "626px" }}>
                {isMapEnabled ? (
                    <iframe
                        title={props.project?.projectAddress1}
                        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDswP272vF5WZVy9n8lBai1df9bbuvzblI&q=${props.project?.projectAddress1}`}
                        width="626"
                        height="315"
                        loading="lazy"
                        className="border-0"
                    ></iframe>
                ) : (
                    <div
                        className="d-flex justify-content-center align-items-center position-relative "
                        style={{ width: "626px", height: "315px" }}
                    >
                        <img
                            src={MapPreviewImage}
                            alt="mapImage"
                            width="100%"
                            height="100%"
                            style={{ filter: "blur(5px)" }}
                        />
                        <button
                            className="btn btn-primary  font-normal font-weight-bold position-absolute "
                            onClick={() => setIsMapEnabled(true)}
                        >
                            View Map
                        </button>
                    </div>
                )}
            </div>
            <div className="col-12 px-0 font-sm">
                <div className="mb-1">{props.project?.city?.cityName}</div>
                <div>
                    <i className="icon-location-filled mr-2 text-gray-500"></i>
                    {props.project?.projectAddress1}
                </div>
            </div>
        </div>
    );
}
